<script lang="ts">
  import type { Race } from '$types/races';
  import { gotoRace } from '$utils/navigation';

  import { formatRaceStartTimeWithDay } from '$utils/time';
  import { priceAlertsDialog } from './PriceAlertsModal.svelte';
  import RaceTypeBadge from './race/RaceTypeBadge.svelte';

  export let race: Race | undefined;

  async function goto() {
    if (!race) return;
    priceAlertsDialog.close();
    await gotoRace(race);
  }
</script>

{#if race && race?.id}
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    on:click={goto}
    on:keypress={goto}
    class="flex cursor-pointer items-center space-x-4 bg-gray-100 p-3 text-sm font-semibold text-gray-800 hover:bg-gray-200"
  >
    <div class="flex min-w-0 flex-1 flex-row">
      <div class="flex-col">
        <div class="flex flex-row items-center">
          <RaceTypeBadge {race} />
          <span class="ml-2 font-semibold">
            R{race.number}
            {race.meeting?.track}
          </span>
        </div>
      </div>
    </div>
    <div class=" ">
      {formatRaceStartTimeWithDay(race.startTime)}
    </div>
  </div>
{/if}
